import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  auth: {
    email: "",
    idToken: "",
    localId: "",
    expiresIn: "",
    refreshToken: "",
  },
  isLogin: false,
  errorMessage: "",
  successMessage: "",
  showLoading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state) => {
      state.isLogin = true;
    },
    logout: (state) => {
      state.isLogin = false;
    },
  },
});

export const { logout, login } = authSlice.actions;

export default authSlice.reducer;
